import { spacings } from "@/assets/themes";
import { Block, Button, List, Modal, Spinner } from "@/components";
import { CardBase } from "@/components/Styles/Base";
import { useGetRecurringJobs } from "@/modules/routes/recurring-jobs-routes";
import { formatDate, getTranslatedDay } from "@/utils";
import polyglot from "@/utils/polyglot";
import { RECURRING_JOBS_NEW_PATH } from "../dashboard/config/routes";
import JobsItem from "../dashboard/jobs/JobsItem";

const JobberRecurringJobsModal = ({ jobber, isOpen, close }) => {
  const { data, isLoading } = useGetRecurringJobs(jobber.id);

  return (
    <Modal.Small onClose={close} isOpen={isOpen} fullScreenOnMobile>
      <Modal.Item.Header onClose={close}>
        <Modal.Item.Title>
          {polyglot.t("recurring.jobs_with_first_name", {
            first_name: jobber.first_name,
          })}
        </Modal.Item.Title>
      </Modal.Item.Header>
      <Modal.Item.Wrapper>
        {!isLoading ? (
          <Block display="flex" flexDirection="column" gap={spacings.sm}>
            {data?.recurring_jobs?.length > 0 && (
              <List.Group>
                {data?.recurring_jobs?.map((item) => (
                  <JobsItem
                    key={item.id}
                    {...item}
                    id={item.job_id}
                    subtitle={polyglot.t(
                      `frequency.with_context.${item.frequency}`,
                      {
                        day: getTranslatedDay(item.wday).toLowerCase(),
                        day_number: formatDate(item.date, "DD"),
                        position:
                          item.wposition &&
                          [
                            polyglot.t("frequency.first"),
                            polyglot.t("frequency.second"),
                            polyglot.t("frequency.third"),
                            polyglot.t("frequency.last"),
                          ][item.wposition - 1]?.toLowerCase(),
                      }
                    )}
                  />
                ))}
              </List.Group>
            )}
          </Block>
        ) : (
          <Block
            display="flex"
            justifyContent="center"
            alignItems="center"
            padding={spacings.m}
          >
            <Spinner.Medium />
          </Block>
        )}
      </Modal.Item.Wrapper>
      <Modal.Item.Footer column>
        <Button.Large
          block
          href={`${RECURRING_JOBS_NEW_PATH}?jobber_id=${jobber.id}`}
        >
          {polyglot.t("jobs.add_recurring")}
        </Button.Large>
      </Modal.Item.Footer>
    </Modal.Small>
  );
};

export default JobberRecurringJobsModal;
